import { FunctionComponent } from 'react';
import Spinner from 'react-bootstrap/Spinner'

const LoadingSpinner: FunctionComponent = () => {
    return (
        <div className="text-center">
            <h2 className="mb-4">Loading...</h2>
            <Spinner animation="border" variant="primary" role="status" style={{ width: '4rem', height: '4rem' }}>
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};

export default LoadingSpinner;
